import React from 'react';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import ProductsPage from './components/ProductsPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import DataDeletion from './components/DataDeletion';
import TermsOfService from './components/TermsOfService';
import ChatWindow from './components/ChatWindow';
import './App.css';

// Root Layout Component
function RootLayout() {
  return <Outlet />;
}

// Router configuration
export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <LandingPage />,
      },
      {
        path: "products",
        element: <ProductsPage />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "data-deletion", 
        element: <DataDeletion />,
      },
      {
        path: "terms-of-service",
        element: <TermsOfService />,
      },
      {
        path: "chat/:id",
        element: <ChatWindow />,
      },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;